import SelectStyled from "@/components/SelectStyled";
import { ZipcodeSelector } from "@/components/ZipcodeSelector";
import { InputLabel, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";

export const SurroundingSearchFilter = ({
  zipcode,
  radius,
  disabled = false,
  onChange,
}) => {
  const handleInputChanged = (event, value = null) => {
    if (onChange) {
      onChange(event, value);
    }
  };

  const values = [
    {
      value: "100",
      label: "100 Kilometer",
    },
    {
      value: "50",
      label: "50 Kilometer",
    },
    {
      value: "10",
      label: "10 Kilometer",
    },
  ];

  return (
    <>
      <InputLabel disabled={disabled}>Umkreissuche</InputLabel>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <ZipcodeSelector
            hint="Postleitzahl"
            name="zipcode"
            defaultValue={zipcode}
            onChange={handleInputChanged}
            placeholder="Deine PLZ"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectStyled
            values={values}
            name="radius"
            value={radius}
            onChange={handleInputChanged}
            allowEmpty={true}
            disabled={disabled}
          >
            {values.map((option, key) => (
              <MenuItem value={option} key={key}>
                {option.label}
              </MenuItem>
            ))}
          </SelectStyled>
        </Grid>
      </Grid>
    </>
  );
};
